import React, { useMemo } from 'react';
import Card from '../../../../componentes/contenedores/Card';
import Page from '../../../../componentes/plantilla/Page';
import { useContextUsuario } from "../../../../contexto/usuario/UsuarioContext";
import ModalTipoProducto from './ModalTipoProducto';
import { useContextEmpleado } from "../../../../contexto/empleado/EmpleadoContext";
import Tablas from "../../../../componentes/tablas/TablasGenerico";
import EliminarTipoProducto from './EliminarTipoProducto';
import { createRoot } from 'react-dom/client';

const HomeTiposProductos = () => {
    const { listaTiposProductos, setListaTiposProductos, ActualizarLista } = useContextEmpleado();
    const { token } = useContextUsuario();
    const datos = {
        titulo: {
            titulo: "Nueva categoria de producto",
            url: "/app/admin/productos/tipos",
            tituloUrl: "productos",
            nombreUrl: "tipos"
        }
    };

    const columnasTiposProducto = useMemo(
        () => [
            { targets: 0, title: "Id", data: "id" },
            { targets: 1, title: "Nombre", data: "nombre" },
            { targets: 2, title: "Descripción", data: "descripcion" },
            {
                targets: 3, title: "Estado", data: "estado",
                render: (data) => {
                    return `<span class="badge ${data === "Activo" ? "badge-success" : "badge-danger"}">${data}</span>`;
                }
            },
            {
                targets: 4,
                title: "Opciones",
                data: null,
                orderable: false,
                searchable: false,
                className: 'dt-center all',
                createdCell: (td, cellData, rowData) => {
                    const root = createRoot(td);
                    root.render(
                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "1em" }}>
                            <ModalTipoProducto
                                datos={rowData}
                                token={token}
                                setListaTiposProductos={setListaTiposProductos}
                                ActualizarLista={ActualizarLista}
                            />
                            <EliminarTipoProducto
                                datos={rowData}
                                token={token}
                                setListaTiposProductos={setListaTiposProductos}
                                ActualizarLista={ActualizarLista}
                            />
                        </div>
                    );
                },
            },
        ],
        [token, setListaTiposProductos, ActualizarLista]
    );

    return (
        <Page datos={datos}>
            <Card
                titulo="Modulo de gestión de categorias"
                pie={<ModalTipoProducto token={token} setListaTiposProductos={setListaTiposProductos} ActualizarLista={ActualizarLista} />}
            >
                <div>
                    <p className="card-text">
                        Este módulo ayuda en la organización y administrasión de las categorias de los productos.
                    </p>
                </div>
            </Card>
            <Card titulo="Lista de categorias">
                <Tablas
                    datos={listaTiposProductos}
                    columnas={columnasTiposProducto}
                    id="tablaTiposProductos"
                />
            </Card>
        </Page>
    )
}

export default HomeTiposProductos;